import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules, Route } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { OfflineDashboardComponent } from './dashboard/offline/offline-dashboard.component';
import { ProfileComponent } from './profile/profile.component';
import { ReleaseNoteComponent } from './header/release-note/release-note.component';
import { LayoutComponent } from './layout.component';
import { DebugComponent } from './debug/debug.component';
import { OnlineGuard } from './online.guard';
import { ErrorPageComponent } from './shared/errors/error-page/error-page.component';
import { AppAuthGuard } from './auth/app-auth.guard';
import { AdminGuard } from '@app/admin.guard';
import { AdminV2Guard } from '@app/admin-v2/admin-v2.guard';
import { HealthComponent } from './health/health.component';
import { CallbackComponent } from './auth/callback.component';
import { SupportComponent } from '@app/support/support.component';
const adminRoute: Route = {
  path: 'admin',
  loadChildren: () => import('src/app/admin/admin.module').then((m) => m.AdminModule),
  canActivate: [AppAuthGuard],
  // Child guards run after the parent's, so AdminGuard's API call waits for login.
  canActivateChild: [AdminGuard],
};

const adminV2Route: Route = {
  path: 'admin-v2',
  loadChildren: () => import('@app/admin-v2/admin-v2.module').then((module) => module.AdminV2Module),
  canActivate: [AppAuthGuard],
  canActivateChild: [AdminV2Guard],
};

const callbackRoute: Route = {
  path: 'callback',
  component: CallbackComponent,
};

const healthRoute: Route = {
  path: 'health',
  component: HealthComponent,
};

const appRoute: Route = {
  path: '',
  canActivate: [AppAuthGuard],
  component: LayoutComponent,
  children: [
    { path: '', component: DashboardComponent, pathMatch: 'full', canActivate: [OnlineGuard] },
    { path: 'offline', component: OfflineDashboardComponent },
    {
      path: 'work-order/:id',
      canActivate: [AppAuthGuard],
      loadChildren: () => import('src/app/work-order/work-order.module').then((m) => m.WorkOrderModule),
    },
    { path: 'profile', component: ProfileComponent, canActivate: [OnlineGuard] },
    { path: 'release-note', component: ReleaseNoteComponent },
    { path: 'debug', component: DebugComponent },
    {
      path: 'model-3d-viewer',
      loadComponent: () =>
        import('@app/work-order/documents/model-3d-viewer/model-3d-viewer.component').then(
          (m) => m.Model3dViewerComponent,
        ),
    },
    { path: 'error/:errorCode', component: ErrorPageComponent },
    { path: 'support', component: SupportComponent },
    { path: '**', redirectTo: 'error/404' },
  ],
};

const routes: Routes = [healthRoute, callbackRoute, adminRoute, adminV2Route, appRoute];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
